import React, { Component } from 'react'
import { Modal, Image, Typography, Button, notification } from 'antd';
import Gift from '../../assets/images/gift.png'
import { CopyToClipboard } from "react-copy-to-clipboard";

const { Title, Paragraph } = Typography
class ModalPromo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            copy: false,
        }
    }
    render() {
        return (
            <Modal
                // visible={true}
                visible={this.props.visible}
                footer={false} width={700} onCancel={this.props.close}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Image loading="lazy"  preview={false} src={Gift} style={{ height: '120px', width: '150px' }} />

                </div>
                <div style={{ textAlign: 'center' }}>

                    <Title level={2}>Thank you for subscribing</Title>
                    <Paragraph style={{ fontSize: '18px' }}>Here is your reward! <br />Apply this promo code in your next booking to avail 10% off</Paragraph>
                    <div style={{ width: '60%', margin: 'auto', marginBottom: '1rem' }}>

                        {this.state.copy == false ? <Paragraph style={{ border: '1px solid #ff6f4d', fontSize: '18px', color: "#ff6f4d", margin: 0, height: '50px', paddingTop: '0.5rem' }}>{this.props.promo ? this.props.promo : 'Welcome'}</Paragraph>
                            : <Paragraph style={{ border: '1px solid black', transition: '0.5s ease-out', fontSize: '18px', color: "white", margin: 0, height: '50px', paddingTop: '0.5rem', backgroundColor: 'black' }}>Copied</Paragraph>}
                        <CopyToClipboard text={this.props.promo ? this.props.promo : 'Welcome'}>
                            <Button style={{ backgroundColor: '#ff6f4d', width: '100%', height: '50px', marginTop: '-0.1rem', color: 'white', fontSize: '18px', border: '1px solid #ff6f4d' }}
                                onClick={() => {

                                    this.setState({ copy: true })
                                    setTimeout(function () {

                                        this.setState({ copy: false })
                                    }.bind(this), 2000)
                                }}>
                                Copy
                            </Button>
                        </CopyToClipboard>
                    </div>

                </div>
            </Modal >
        )
    }
}

export default ModalPromo